import { toast } from "sonner";
import { z } from "zod";

import { BaseForm, FormInput, FormTextarea } from "components/BaseForm";
import { useTagCategoryMutations } from "hooks/useTagCategoryTable";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().nullable(),
});

const TagCategoryForm = ({ model, onSuccess, onCancel }) => {
  const isEdit = !!model?.id;
  const { create, update } = useTagCategoryMutations();

  const handleSubmit = async ({ name, description }) => {
    const data = { name, description };
    if (isEdit) {
      await update.mutateAsync({ id: model.id, data });
    } else {
      await create.mutateAsync(data);
    }
  };

  const handleSuccess = () => {
    toast.success(isEdit ? "Tag category updated" : "Tag category created");
    onSuccess();
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{
        name: model?.name ?? "",
        description: model?.description ?? "",
      }}
      onSubmit={handleSubmit}
      onSuccess={handleSuccess}
      onCancel={onCancel}
      submitButtonText="Save"
    >
      <FormInput name="name" label="Name" required />
      <FormTextarea name="description" label="Description" />
    </BaseForm>
  );
};

export default TagCategoryForm;
